import React from 'react';
import { LegendItemContainer } from './style';

export const LegendItem = ({
  backgroundColor,
  iconComponent,
  legendLabel,
}) => {
  return (
    <LegendItemContainer backgroundColor={backgroundColor}>
      <div className='iconContainer'>{iconComponent}</div>
      <div className='legendLabel'>{legendLabel ? legendLabel : 'error'}</div>
    </LegendItemContainer>
  );
};
